export const UNSAVED_MESSAGE =
  'List of items might change. Do you want to continue?';



// WEBPACK FOOTER //
// ./src/common/Constants/modal.js